import React from 'react';

import ModalType from '../../models/ModalType';
import CheckEligibility from '../checkEligibility/CheckEligibility';
import ConsultPrices from '../consultPrices/ConsultPrices';
import HeadbandModal from '../headbandModal/HeadbandModal';

import { useModal } from '../../context/ModalContext';

import './Modal.scss';

export default function Modal() {
  const { currentModal } = useModal();

  const { modal, props } = currentModal;

  return (
    <div className={`modal-container ${modal !== null && 'active'} ${modal === ModalType.HEADBAND && 'stick-bottom'}`}>
      {modal === ModalType.CHECK_ELIGIBILITY && (
        // eslint-disable-next-line react/prop-types
        <CheckEligibility startResult={props.result} />
      )}

      {modal === ModalType.PRICES && (
        <ConsultPrices />
      )}

      {modal === ModalType.HEADBAND && (
        <HeadbandModal />
      )}
    </div>
  );
}
